<template>
   <div id="reporting_view">
       <div v-if="is_built">
           <div class="row justify-content-center">
               <div class="col px-0">
                   <div class="top-image-wrap">
                       <template v-if="loaded && !!report_image">
                           <img remote :src="report_image" />
                       </template>
                       <template v-else-if="loaded">
                           <img :src="`${$store.state.app_url}images/new-york.jpg`" />
                       </template>
                       <div class="container-fluid headings">
                           <div class="row row-cols-2 justify-content-center">
                               <div class="col d-flex flex-column justify-content-center">
                                   <p class="client-name header-text">{{client_name}}</p>
                               </div>
                               <div class="col date-wrap d-flex flex-column justify-content-center align-items-center">
                                   <div>
                                       <h4 class="mb-0 header-text top-right">REPORTING</h4>
                                       <span v-if="year_from == year_to" class="date-wrap text-uppercase header-text top-right"><span>{{$dayjs(date_from).format("MMM DD")}}</span> - <span>{{$dayjs(date_to).format("MMM DD")}}</span>, <span>{{$dayjs(date_from).format("YYYY")}}</span></span>
                                       <span v-else class="date-wrap text-uppercase header-text top-right"><span>{{$dayjs(date_from).format("MMM DD, YYYY")}}</span> - <span>{{$dayjs(date_to).format("MMM DD, YYYY")}}</span></span>
                                       <template v-if="hasVillaniGroup">
                                           <p class="mt-3 font-weight-normal header-text smaller">Prepared by Knightsbridge Park <br> & Villani Group</p>
                                       </template>
                                       <template v-else>
                                           <p class="mt-3 font-weight-normal header-text smaller">Prepared by Knightsbridge Park</p>
                                       </template>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <report-elements-component ref="reportElementsComponent" :isBuilt="is_built" :hasSkb="has_skb" :elementsData="elements_data" :report-or-archive="reportOrArchiveData" :isGuest="is_guest"></report-elements-component>
       </div>
    </div>
</template>

<script>
   import reportElementsComponent from './ReportElementsComponent.vue';

   export default {
      created(){
         let url;
          if(this.$route.path.includes('/skb/')){
              this.has_skb = true;
          }
         if(this.$route.path.includes('/report/')){
            let reportId = this.$route.params.report_id;
            url = this.$route.path.includes('query') ? `/api/reporting/report/${reportId}/query` : `/api/reporting/report/${reportId}`;
            this.$store.commit('setIsArchive',0);
         }
         else{
            let archiveId = this.$route.params.archive_id;
            url = this.$route.path.includes('query') ? `/api/reporting/archive/${archiveId}/query` : `/api/reporting/archive/${archiveId}`;
            this.$store.commit('setIsArchive',1);
         }
          event_bus.$on('calendar_saved', (param) => {
              this.period = this.$store.state.current_dates.main_period + ' vs ' + this.$store.state.current_dates.compare_period;
              this.date_from = this.$store.state.current_dates.date_from;
              this.date_to = this.$store.state.current_dates.date_to;
              this.date_compare_from = this.$store.state.current_dates.date_compare_from;
              this.date_compare_to = this.$store.state.current_dates.date_compare_to;
              this.year_from = parseInt(this.date_from);
              this.year_to = parseInt(this.date_to);
              this.year_compare_from = parseInt(this.date_compare_from);
              this.year_compare_to = parseInt(this.date_compare_to);
          });

         axios.get(url).then((response) => {
            if(this.$store.state.url_params){
                const params = JSON.parse(this.$store.state.url_params);
                this.$store.commit('setCurrentDates',params.dates);
                this.$store.commit('setCurrentDWM',params.dwm);
            }
            else{
                this.$store.commit('setCurrentDates',response.data.initDates);
                this.$store.commit('setCurrentDWM',response.data.defaultDWM);
                this.report_id = response.data.report_id;
            }

            this.$store.commit('setDateFormat',response.data.dateFormat);
            this.$store.commit('setHasFilters',response.data.hasFilters);
            this.$store.commit('setIsArchive',response.data.isArchive);
            this.$store.commit('setShowQueries',response.data.showQueries);

            this.isArchive     = this.$store.state.isArchive;
            this.edit_mode    =  !!this.$route.params.query && (this.$route.params.query == 'edit');
            this.has_filters  = this.$store.state.hasFilters;
            this.current_dwm  = this.$store.state.current_dwm;

             this.date_from = this.$store.state.current_dates.date_from;
             this.date_to = this.$store.state.current_dates.date_to;
             this.date_compare_from = this.$store.state.current_dates.date_compare_from;
             this.date_compare_to = this.$store.state.current_dates.date_compare_to;
             this.year_from = parseInt(this.date_from);
             this.year_to = parseInt(this.date_to);
             this.year_compare_from = parseInt(this.date_compare_from);
             this.year_compare_to = parseInt(this.date_compare_to);

             event_bus.$on('filters', (param) => {
               this.has_filters = param;
            });

            event_bus.$emit('date_infos', true);

            if(!this.has_filters){
                this.hide_filters = false;
            }

            this.is_built = response.data.isBuilt;

            if(this.isArchive){
                this.$route.params.report_id = this.report_id;
            }

            this.fetchServerData();
         });
      },
      mounted(){

      },

      data() {
         return {
             isArchive:null,
             is_built:true,
             is_guest:false,
             has_skb:false,
             date_from:null,
             date_to:null,
             date_compare_from:null,
             date_compare_to:null,
             year_from:null,
             year_to:null,
             year_compare_from:null,
             year_compare_to:null,
             name:'',
             report_id: null,
             report_name: '',
             client_name:'',
             report_image:null,
             edit_mode: null,
             elements_data: null,
             has_filters:null,
             hide_filters: false,
             initDates: '',
             current_dwm:null,
             editText:'Create archive',
             groups:null,
             reportOrArchiveData:null,
             hasMixedMetrics:false,
             hasComments:false,
             excel_export_data_sources: [],
             excel_export_options:null,
             hasVillaniGroup:false,
             loaded:false,
             submitted:false,
         }
      },
      methods: {
         fetchServerData() {
            const vueInstance = this;
            let current_dates = this.$store.state.current_dates;
            let dates = {
               'date_from':current_dates['date_from'],
               'date_to':current_dates['date_to'],
               'date_compare_from':current_dates['date_compare_from'],
               'date_compare_to':current_dates['date_compare_to']
            };
            dates = JSON.stringify(dates);
            if(this.$store.state.isArchive){
               axios.all([
                   axios.get(`/api/reports/${this.report_id}?archive_id=${this.$route.params.archive_id}`),
                   axios.get(`/api/reports/${this.report_id}/view?dates=${dates}&archive_id=${this.$route.params.archive_id}`)
               ]).then(axios.spread((reportInfos, reportData) => {
                   if (reportInfos.data) {
                       this.reportOrArchiveData = reportInfos.data;
                       this.name = reportInfos.data.title;
                       document.title = reportInfos.data.archive_name;
                   }
                   if(reportData.data){
                       this.elements_data = reportData.data;
                       this.report_name = reportData.data.name;
                       this.client_name = !!reportData.data[0] && !!reportData.data[0].client_name ? reportData.data[0].client_name : '';
                       this.report_image = !!reportData.data[0] && !!reportData.data[0].report_image ? 'https://f000.backblazeb2.com/file/kbpark/' + reportData.data[0].report_image : null;
                       this.hasVillaniGroup = !!reportData.data[0] && !!reportData.data[0].has_villani ? reportData.data[0].has_villani : false;
                       _.each(this.elements_data, (element, idx) => {
                           if(_.has(element.element_configurations, 'num_rows')){
                               if(!parseInt(element.element_configurations.num_rows)){
                                   this.elements_data[idx].element_configurations.num_rows = element.element_abbreviation == 'single_table_grouping' ? 5 : 10;//workaround
                               }
                           }
                       });
                   }
               }));
            }
            else{
               axios.all([
                  axios.get(`/api/reports/${this.$route.params.report_id}`),
                  axios.get(`/api/reports/${this.$route.params.report_id}/view?dates=${dates}`)
               ]).then(axios.spread((reportInfos, reportData) => {
                  if (reportInfos.data) {
                      this.reportOrArchiveData = reportInfos.data;
                      this.name = reportInfos.data.name;
                      document.title = reportInfos.data.name;
                  }
                  if(reportData.data){
                      this.elements_data = reportData.data;
                      this.report_name = reportData.data.name;
                      this.client_name = !!reportData.data[0] && !!reportData.data[0].client_name ? reportData.data[0].client_name : '';
                      this.report_image = !!!!reportData.data[0] && !!reportData.data[0].report_image ? 'https://f000.backblazeb2.com/file/kbpark/' + reportData.data[0].report_image : null;
                      this.hasVillaniGroup = !!reportData.data[0] && !!reportData.data[0].has_villani ? reportData.data[0].has_villani : false;
                      _.each(this.elements_data, (element, idx) => {
                          if(_.has(element.element_configurations, 'num_rows')){
                              if(!parseInt(element.element_configurations.num_rows)){
                                  this.elements_data[idx].element_configurations.num_rows = element.element_abbreviation == 'single_table_grouping' ? 5 : 10;//workaround
                              }
                          }
                      });
                  }

                  this.initDates = this.$store.state.current_dates;
               }));
            }
         },
         updateElements(event) {
            var target = $(event.target);
            if (target.hasClass('btn-timing-active') || target.hasClass('pending')) {
               return false;
            }

            target.closest('.btn-group').find('.dwm').removeClass('btn-timing-active');
            target.addClass('btn-timing-active');

            var dwm = target.attr('id');
            this.current_dwm = dwm;
            this.$store.commit('setCurrentDWM',dwm);
            event_bus.$emit('current_dwm', true);
            this.showLoader();
         },
         toggleEditMode() {
            this.edit_mode = !this.edit_mode;
            if(!this.edit_mode){
               $('#reporting_data').find('.froala').froalaEditor('destroy');
            }
         },
         toggleFilter() {
            this.hide_filters = !this.hide_filters;
         }
      },
      watch: {
         report_name(value) {
            this.editText = (value == '') ? 'Create report' : 'Edit report';
         },
         edit_mode(value){
            if(value){
               window.history.pushState(null, null, window.location.href.replace(/\/edit$/, ''));
               window.history.pushState(null, null, window.location.href.replace(/^.*$/, window.location.href+'/edit'));
            }
            else{
               window.history.pushState(null, null, window.location.href.replace(/\/edit$/, ''));
            }
         },
         elements_data(value){
            if(!!value){
               this.loaded = true;
            }
         }
      },
      components: {
         'report-elements-component': reportElementsComponent
      }
   }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
   #reporting_view {
       .header-text{
           text-shadow: 2px 2px 4px #000000;
           &.top-right{
               letter-spacing:0.2rem !important;
               font-size:1.3vw !important;
               font-weight:bold !important;
               @media screen and (max-width: 992px) {
                   margin-left:-1rem;
               }
               @media screen and (max-width: 700px) {
                   margin-left:-2rem;
               }
               @media screen and (max-width: 500px) {
                   margin-top:0.4rem;
                   margin-left:-5rem;
               }
           }
           &.smaller{
               font-family:'BentonSans Regular';
               font-size:1.8rem;
               font-weight:bold !important;
               line-height:2.4rem;
               letter-spacing:0.2rem !important;
               @media screen and (max-width: 992px) {
                   font-size:1.5rem;
                   line-height:1.5rem;
                   margin-left:-1rem;
               }
               @media screen and (max-width: 700px) {
                   font-size:1.2rem;
                   line-height:1.2rem;
                   margin-left:-2rem;
               }
               @media screen and (max-width: 500px) {
                   font-size:0.8rem;
                   line-height:1rem;
                   margin-left:-5rem;
               }
               @media screen and (max-width: 400px) {
                   font-size:0.6rem;
                   line-height:1rem;
                   margin-left:-5.5rem;
               }
           }
       }
       div.top-image-wrap{
           position:relative;
           overflow:hidden;
           color:white;
           padding: 0 3rem;
           div.headings{
               position:absolute;
               left:0;
               top:0;
               height:100%;
               & > div{
                   height:100%;
               }
               p.client-name{
                   font-family:'Chronicle Display Extra Light' !important;
                   font-size:5vw;
                   padding:0 6rem;
                   @media screen and (max-width: 700px) {
                       font-size:4vw;
                       padding:0 4rem;
                   }
                   @media screen and (max-width: 500px) {
                       font-size:3vw;
                       padding:0 3rem;
                   }
               }
               div.date-wrap{
                   font-size:1.6vw;
                   font-weight:bold;
                   span{
                       font-size:1.3vw;
                   }
               }
           }
           img{
               width:100%;
               max-width:100%;
               border-radius: 3rem;
           }
       }
       h1{
           position:relative;
           &.perf-act-highlights{
               padding-bottom:1rem;
               font-size:6rem;
               color:#052738;
           }
           &.serif{
               font-family:'Chronicle Display Extra Light';
           }
           button{
               position:absolute;
               top:calc(50% - 1.5rem);
               right:0;
               &.edit.hasGPT{
                   right:8rem;
               }
           }
       }
       span.h-line{
           display:inline-block;
           border-top:0.3rem solid;
           border-bottom:0.3rem solid;
           border-radius:0.6rem;
           width:100%;
           color:$black-blue;
       }
       p{
           &.highlights{
               color:#636466;
           }
       }
   }
</style>
